
import { Component, Vue } from "vue-property-decorator";

import QuizForm from "./QuizForm.vue";
import QuizScore from "./QuizScore.vue";
import ConfirmationComponent from "./ConfirmationComponent.vue";
import api from "@/network/api";
import { AxiosResponse } from "axios";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
@Component({
  components: {
    QuizForm,
    QuizScore,
    ConfirmationComponent
  }
})
export default class QuizPage extends Vue {
  @Getter("userLanguageId") private currentLanguage!: Language;
  private showForm = false;
  private showScore = false;
  private showError = false;
  private errorMsg = "";
  private currentQuestion = 0;
  lesson: any = {};
  score = 0;
  showConfirmationBox = false;
  clickedButton: "next" | "submit" = "next";

  loadQuiz() {
    this.showForm = false;
    this.showScore = false;
    const lessonParam = this.$route.query.lesson;
    api
      .get("lesson_quiz/" + lessonParam)
      .then((res: AxiosResponse) => {
        this.lesson = res.data;
        if (res.data.status === "ready") {
          this.showForm = true;
        } else if (res.data.status === "taken") {
          this.showScore = true;
        }
      })
      .catch(error => {
        if (error.data && error.data.message) {
          this.errorMsg = error.data.message;
          this.showError = true;
        }
      });
  }

  created() {
    this.loadQuiz();
  }

  checkEmpty(clickedButton: "next" | "submit") {
    const didAnswer = this.lesson.questions[this.currentQuestion]
      .selected_answer;
    if (!didAnswer) {
      this.showConfirmationBox = true;
      this.clickedButton = clickedButton;
    } else if (clickedButton === "next") {
      this.clickedButton = clickedButton;
      this.nextQuestion();
    } else if (clickedButton === "submit") {
      this.clickedButton = clickedButton;
      this.submitAnswers();
    }
  }

  nextQuestion() {
    this.currentQuestion++;
    if (this.currentQuestion >= this.lesson.questions.length) {
      this.currentQuestion = this.lesson.questions.length - 1;
    }
  }

  prevQuestion() {
    this.currentQuestion--;
    if (this.currentQuestion < 0) {
      this.currentQuestion = 0;
    }
  }

  submitAnswers() {
    const userAnswers: any = [];
    this.lesson.questions.forEach((ques: any) => {
      userAnswers.push({
        // eslint-disable-next-line @typescript-eslint/camelcase
        question_id: ques.id,
        // eslint-disable-next-line @typescript-eslint/camelcase
        selected_answer: ques.selected_answer
      });
    });
    api
      .post("lesson_quiz", {
        // eslint-disable-next-line @typescript-eslint/camelcase
        lesson_id: this.lesson.id,
        // eslint-disable-next-line @typescript-eslint/camelcase
        questions: userAnswers
      })
      .then((res: AxiosResponse) => {
        this.loadQuiz();
      });
  }

  allowAction() {
    if (this.clickedButton === "next") {
      this.nextQuestion();
    } else if (this.clickedButton === "submit") {
      this.submitAnswers();
    }
    this.showConfirmationBox = false;
  }
}
